export const DEFAULT_PATTERN_LAB_COLORS = [
    '#0d77d5',
    '#ccb800',
    '#a600cc',
] as const;
